import React from "react";

import {
  Box,
  BoxProps,
  ThemingProps,
  Flex,
  FlexProps,
  StylesProvider,
  useMultiStyleConfig,
  useStyles,
} from "@chakra-ui/react";

export type CardProps = ThemingProps & BoxProps;

export const CardHeader = ({
  children,
  ...rest
}: React.PropsWithChildren<FlexProps>): React.ReactElement => {
  const styles = useStyles();
  return (
    <Flex __css={styles.header} {...rest}>
      {children}
    </Flex>
  );
};

export const CardBody = ({
  children,
  ...rest
}: React.PropsWithChildren<FlexProps>): React.ReactElement => {
  const styles = useStyles();
  return (
    <Flex __css={styles.body} {...rest}>
      {children}
    </Flex>
  );
};

const Card = ({
  variant,
  children,
  ...rest
}: React.PropsWithChildren<CardProps>): React.ReactElement => {
  const styles = useMultiStyleConfig("Card", { variant });

  return (
    <Box __css={styles.card} {...rest}>
      <StylesProvider value={styles}>{children}</StylesProvider>
    </Box>
  );
};

export default Card;
